import { render, staticRenderFns } from "./drawTwoComponent.vue?vue&type=template&id=5af8ce8e&scoped=true&"
import script from "./drawTwoComponent.vue?vue&type=script&lang=js&"
export * from "./drawTwoComponent.vue?vue&type=script&lang=js&"
import style0 from "./drawTwoComponent.vue?vue&type=style&index=0&id=5af8ce8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af8ce8e",
  null
  
)

export default component.exports